import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import "./address-add-update.less";
import {
  getDistrictListApi,
  getProvinceListApi,
  getWardListApi,
} from "states/address/address.api";
import {
  DistrictModel,
  ProvinceModel,
  WardModel,
} from "states/address/address.models";
import { setActiveSidebar } from "states/app-setting/app-setting.action";
import {
  createCustomerAddressApi,
  getCustomerAddressApi,
  updateCustomerAddressApi,
} from "states/customer-address/customer-address.api";
import { CustomerAddressModel } from "states/customer-address/customer-address.models";
import {
  globalValueSetLoading,
  globalValueSetToast,
} from "states/global-value/global-value.action";
import {
  ToastModel,
  ToastType,
} from "states/global-value/global-value.models";
import "./address.less";
import { DefaultErrorMessage, UpdateDataSuccessfully } from "shared/constants/message";

interface AddressAddUpdateProps {}
interface ParamsRoute {
  id: string;
}

const AddressAddUpdate = (props: AddressAddUpdateProps) => {
  const dispatch = useDispatch();
  const [customerAddress, setCustomerAddress] = useState<CustomerAddressModel>(
    {} as CustomerAddressModel
  );
  const [provinces, setProvinces] = useState<ProvinceModel[]>([]);
  const [districts, setDistricts] = useState<DistrictModel[]>([]);
  const [wards, setWards] = useState<WardModel[]>([]);
  document.title = "Danh sách địa chỉ";
  const params = useParams<ParamsRoute>();
  const [isUpdate, setIsUpdate] = useState<boolean>(true);
  const _handleGetAddress = async () => {
    try {
      let result = await getCustomerAddressApi(params?.id);
      setCustomerAddress(result.data);
      _handleGetDistricts(result.data.provinceId);
      _handleGetWards(result.data.districtId);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetProvince = async () => {
    try {
      let result = await getProvinceListApi();
      setProvinces(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetDistricts = async (id: string | number) => {
    try {
      let result = await getDistrictListApi(id);
      setDistricts(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleGetWards = async (id: string | number) => {
    try {
      let result = await getWardListApi(id);
      setWards(result.data);
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleSubmit = async () => {
    dispatch(globalValueSetLoading(true));
    try {
      if(isUpdate){
        await updateCustomerAddressApi(customerAddress)
      }else{
        await createCustomerAddressApi(customerAddress);
        window.location.reload();
      }
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: UpdateDataSuccessfully,
          type: ToastType.success,
        } as ToastModel)
      );
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  useEffect(() => {
    if (document.location.href.indexOf("account/addresses/add") > 0) {
      setIsUpdate(false);
    } else {
      _handleGetAddress();
    }
    dispatch(setActiveSidebar("address"));
    _handleGetProvince();
  }, []);
  return (
    <React.Fragment>
      <div className="head">{isUpdate ? `Cập nhật` : `Thêm`} địa chỉ</div>
      <div className="content address-update">
      <div className="form-group">
          <label className="name">
            Họ và tên (<span className="required">*</span>)
          </label>
          <input
            type="text"
            value={customerAddress?.name ?? ""}
            onChange={(ev) => {
              setCustomerAddress({
                ...customerAddress,
                name: ev.target.value,
              });
            }}
            className="form-control"
            placeholder="Họ và tên"
          />
        </div>
        <div className="form-group">
          <label className="name">
           Số điện thoại (<span className="required">*</span>)
          </label>
          <input
            type="text"
            value={customerAddress?.phoneNumber ?? ""}
            onChange={(ev) => {
              setCustomerAddress({
                ...customerAddress,
                phoneNumber: ev.target.value,
              });
            }}
            className="form-control"
            placeholder="Số điện thoại"
          />
        </div>
        <div className="form-group">
          <label className="name">
            Tỉnh / thành phố(<span className="required">*</span>)
          </label>
          <select
            value={customerAddress?.provinceId ?? ""}
            className="form-control"
            onChange={(ev) => {
              if (ev.target.value === null || ev.target.value === "") {
                setDistricts([]);
                setWards([]);
                return false;
              }
              setCustomerAddress({
                ...customerAddress,
                provinceId: Number(ev.target.value),
                districtId: 0,
                wardId: 0
              });
              _handleGetDistricts(ev.target.value);
            }}
          >
            <option value="">Chọn tỉnh / thành phố</option>
            {provinces &&
              provinces.map((province) => (
                <option key={province.id} value={province.id}>
                  {province.name}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label className="name">
            Quận / huyện (<span className="required">*</span>)
          </label>
          <select
            value={customerAddress?.districtId ?? ""}
            onChange={(ev) => {
              if (ev.target.value === null || ev.target.value === "") {
                setWards([]);
                return false;
              }
              setCustomerAddress({
                ...customerAddress,
                districtId: Number(ev.target.value),
              });
              _handleGetWards(ev.target.value);
            }}
            className="form-control"
          >
            <option value="">Chọn quận / huyện</option>
            {districts &&
              districts.map((district) => (
                <option key={district.id} value={district.id}>
                  {district.name}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label className="name">
            Xã (<span className="required">*</span>)
          </label>
          <select
            value={customerAddress?.wardId ?? ""}
            onChange={(ev) => {
              if (ev.target.value === null || ev.target.value === "") {
                return false;
              }
              setCustomerAddress({
                ...customerAddress,
                wardId: Number(ev.target.value),
              });
            }}
            className="form-control"
          >
            <option value="">Chọn xã</option>
            {wards &&
              wards.map((ward) => (
                <option key={ward.id} value={ward.id}>
                  {ward.name}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label className="name">
            Địa chỉ (<span className="required">*</span>)
          </label>
          <input
            type="text"
            value={customerAddress?.address ?? ""}
            onChange={(ev) => {
              setCustomerAddress({
                ...customerAddress,
                address: ev.target.value,
              });
            }}
            className="form-control"
            placeholder="Địa chỉ"
          />
        </div>
        <div className="form-group">
          <label className="name" />
          <div className="btn-container">
            <button onClick={_handleSubmit} className="btn btn-primary">
              Cập nhật
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddressAddUpdate;
